import { createFileRoute } from '@tanstack/react-router';

import { ChannelGroupsPage } from '../features/campaigns/channelGroups/components/ChannelGroupsPage/ChannelGroupsPage';

export const Route = createFileRoute('/campaigns/channel-groups')({
  component: ChannelGroupsPage,
});
